export const prospectingMailStatusMapping = {
    new: "Nouveau",
    building: "En construction",
    built: "Prêt",
    sent: "Envoyé",
    received: "Reçu",
    bounced: "Non-délivré",
    error: "Erreur"
};

export const Apprenticeship12and18MonthsProductCodes = ["cap_aepe_alt", "tp_advf_alt", "tp_sama_alt"];
export const FOorder = [
    "DPC",
    "FIFPL",
    "CPF",
    "ALMA",
    "GOCARDLESS",
    "FAFPM",
    "OPCO_EP",
    "OCAPIAT",
    "ATLAS",
    "UNIFORMATION",
    "AKTO",
    "OPCO_MOBILITES",
    "OPCO_SANTE",
    "AFDAS",
    "OPCO_2I",
    "STRIPE",
    "BANK_TRANSFER",
    "AGEFICE",
    "OPCOMMERCE"
];

export const departements = [
    {
        num_dep: "01",
        dep_name: "Ain"
    },
    {
        num_dep: "02",
        dep_name: "Aisne"
    },
    {
        num_dep: "03",
        dep_name: "Allier"
    },
    {
        num_dep: "04",
        dep_name: "Alpes-de-Haute-Provence"
    },
    {
        num_dep: "05",
        dep_name: "Hautes-Alpes"
    },
    {
        num_dep: "06",
        dep_name: "Alpes-Maritimes"
    },
    {
        num_dep: "07",
        dep_name: "Ardèche"
    },
    {
        num_dep: "08",
        dep_name: "Ardennes"
    },
    {
        num_dep: "09",
        dep_name: "Ariège"
    },
    {
        num_dep: 10,
        dep_name: "Aube"
    },
    {
        num_dep: 11,
        dep_name: "Aude"
    },
    {
        num_dep: 12,
        dep_name: "Aveyron"
    },
    {
        num_dep: 13,
        dep_name: "Bouches-du-Rhône"
    },
    {
        num_dep: 14,
        dep_name: "Calvados"
    },
    {
        num_dep: 15,
        dep_name: "Cantal"
    },
    {
        num_dep: 16,
        dep_name: "Charente"
    },
    {
        num_dep: 17,
        dep_name: "Charente-Maritime"
    },
    {
        num_dep: 18,
        dep_name: "Cher"
    },
    {
        num_dep: 19,
        dep_name: "Corrèze"
    },
    {
        num_dep: 21,
        dep_name: "Côte-d'Or"
    },
    {
        num_dep: 22,
        dep_name: "Côtes-d'Armor"
    },
    {
        num_dep: 23,
        dep_name: "Creuse"
    },
    {
        num_dep: 24,
        dep_name: "Dordogne"
    },
    {
        num_dep: 25,
        dep_name: "Doubs"
    },
    {
        num_dep: 26,
        dep_name: "Drôme"
    },
    {
        num_dep: 27,
        dep_name: "Eure"
    },
    {
        num_dep: 28,
        dep_name: "Eure-et-Loir"
    },
    {
        num_dep: 29,
        dep_name: "Finistère"
    },
    {
        num_dep: 20, // not the true num_dep but matches city postal_code
        dep_name: "Corse"
    },
    // {
    //     num_dep: 20, // not the true num_dep but matches city postal_code
    //     dep_name: "Haute-Corse"
    // },
    {
        num_dep: 30,
        dep_name: "Gard"
    },
    {
        num_dep: 31,
        dep_name: "Haute-Garonne"
    },
    {
        num_dep: 32,
        dep_name: "Gers"
    },
    {
        num_dep: 33,
        dep_name: "Gironde"
    },
    {
        num_dep: 34,
        dep_name: "Hérault"
    },
    {
        num_dep: 35,
        dep_name: "Ille-et-Vilaine"
    },
    {
        num_dep: 36,
        dep_name: "Indre"
    },
    {
        num_dep: 37,
        dep_name: "Indre-et-Loire"
    },
    {
        num_dep: 38,
        dep_name: "Isère"
    },
    {
        num_dep: 39,
        dep_name: "Jura"
    },
    {
        num_dep: 40,
        dep_name: "Landes"
    },
    {
        num_dep: 41,
        dep_name: "Loir-et-Cher"
    },
    {
        num_dep: 42,
        dep_name: "Loire"
    },
    {
        num_dep: 43,
        dep_name: "Haute-Loire"
    },
    {
        num_dep: 44,
        dep_name: "Loire-Atlantique"
    },
    {
        num_dep: 45,
        dep_name: "Loiret"
    },
    {
        num_dep: 46,
        dep_name: "Lot"
    },
    {
        num_dep: 47,
        dep_name: "Lot-et-Garonne"
    },
    {
        num_dep: 48,
        dep_name: "Lozère"
    },
    {
        num_dep: 49,
        dep_name: "Maine-et-Loire"
    },
    {
        num_dep: 50,
        dep_name: "Manche"
    },
    {
        num_dep: 51,
        dep_name: "Marne"
    },
    {
        num_dep: 52,
        dep_name: "Haute-Marne"
    },
    {
        num_dep: 53,
        dep_name: "Mayenne"
    },
    {
        num_dep: 54,
        dep_name: "Meurthe-et-Moselle"
    },
    {
        num_dep: 55,
        dep_name: "Meuse"
    },
    {
        num_dep: 56,
        dep_name: "Morbihan"
    },
    {
        num_dep: 57,
        dep_name: "Moselle"
    },
    {
        num_dep: 58,
        dep_name: "Nièvre"
    },
    {
        num_dep: 59,
        dep_name: "Nord"
    },
    {
        num_dep: 60,
        dep_name: "Oise"
    },
    {
        num_dep: 61,
        dep_name: "Orne"
    },
    {
        num_dep: 62,
        dep_name: "Pas-de-Calais"
    },
    {
        num_dep: 63,
        dep_name: "Puy-de-Dôme"
    },
    {
        num_dep: 64,
        dep_name: "Pyrénées-Atlantiques"
    },
    {
        num_dep: 65,
        dep_name: "Hautes-Pyrénées"
    },
    {
        num_dep: 66,
        dep_name: "Pyrénées-Orientales"
    },
    {
        num_dep: 67,
        dep_name: "Bas-Rhin"
    },
    {
        num_dep: 68,
        dep_name: "Haut-Rhin"
    },
    {
        num_dep: 69,
        dep_name: "Rhône"
    },
    {
        num_dep: 70,
        dep_name: "Haute-Saône"
    },
    {
        num_dep: 71,
        dep_name: "Saône-et-Loire"
    },
    {
        num_dep: 72,
        dep_name: "Sarthe"
    },
    {
        num_dep: 73,
        dep_name: "Savoie"
    },
    {
        num_dep: 74,
        dep_name: "Haute-Savoie"
    },
    {
        num_dep: 75,
        dep_name: "Paris"
    },
    {
        num_dep: 76,
        dep_name: "Seine-Maritime"
    },
    {
        num_dep: 77,
        dep_name: "Seine-et-Marne"
    },
    {
        num_dep: 78,
        dep_name: "Yvelines"
    },
    {
        num_dep: 79,
        dep_name: "Deux-Sèvres"
    },
    {
        num_dep: 80,
        dep_name: "Somme"
    },
    {
        num_dep: 81,
        dep_name: "Tarn"
    },
    {
        num_dep: 82,
        dep_name: "Tarn-et-Garonne"
    },
    {
        num_dep: 83,
        dep_name: "Var"
    },
    {
        num_dep: 84,
        dep_name: "Vaucluse"
    },
    {
        num_dep: 85,
        dep_name: "Vendée"
    },
    {
        num_dep: 86,
        dep_name: "Vienne"
    },
    {
        num_dep: 87,
        dep_name: "Haute-Vienne"
    },
    {
        num_dep: 88,
        dep_name: "Vosges"
    },
    {
        num_dep: 89,
        dep_name: "Yonne"
    },
    {
        num_dep: 90,
        dep_name: "Territoire de Belfort"
    },
    {
        num_dep: 91,
        dep_name: "Essonne"
    },
    {
        num_dep: 92,
        dep_name: "Hauts-de-Seine"
    },
    {
        num_dep: 93,
        dep_name: "Seine-Saint-Denis"
    },
    {
        num_dep: 94,
        dep_name: "Val-de-Marne"
    },
    {
        num_dep: 95,
        dep_name: "Val-d'Oise"
    },
    {
        num_dep: 971,
        dep_name: "Guadeloupe"
    },
    {
        num_dep: 972,
        dep_name: "Martinique"
    },
    {
        num_dep: 973,
        dep_name: "Guyane"
    },
    {
        num_dep: 974,
        dep_name: "La Réunion"
    },
    {
        num_dep: 976,
        dep_name: "Mayotte"
    }
];

export const nationality = [
    {
        code: "1",
        id: "Française",
        label: "Française"
    },
    {
        code: "2",
        id: "Union Européenne",
        label: "Union européenne"
    },
    {
        code: "3",
        id: "Extra Européen",
        label: "Hors Union européenne"
    }
];

export const gender = [
    {
        id: "Homme",
        label: "Homme"
    },
    {
        id: "Femme",
        label: "Femme"
    }
];

export const situation_before_contract = [
    {
        code: "",
        id: "unknown",
        label: "Je ne sais pas"
    },
    {
        code: "1",
        id: "school",
        label: "Scolaire"
    },
    {
        code: "2",
        id: "prepa_apprentissage",
        label: "Prépa apprentissage"
    },
    {
        code: "3",
        id: "student",
        label: "Etudiant"
    },
    {
        code: "4",
        id: "apprenticeship_contract",
        label: "Contrat d'apprentissage"
    },
    {
        code: "5",
        id: "professionalization_contract",
        label: "Contrat de professionnalisation"
    },
    {
        code: "6",
        id: "aided_contract",
        label: "Contrat aidé"
    },
    {
        code: "7",
        id: "cfa_formation",
        label: "En formation au CFA sous statut de stagiaire de la formation professionnelle, avant conclusion d'un contrat d'apprentissage (L6222-12-1 du code du travail)"
    },
    {
        code: "8",
        id: "cfa_formation_no_contract",
        label: "En formation, au CFA sans contrat sous statut de stagiaire de la formation professionnelle, à la suite d'une rupture d'un précédent contrat (5° de L6231-2 du code du travail)"
    },
    {
        code: "9",
        id: "other_situations",
        label: "Autres situations sous statut de stagiaire de la formation professionnelle"
    },
    {
        code: "10",
        id: "employee",
        label: "Salarié"
    },
    {
        code: "11",
        id: "job_seeker",
        label: "Personne à la recherche d'un emploi (inscrite ou non à France Travail)"
    },
    {
        code: "12",
        id: "inactive",
        label: "Inactif"
    }
];

export const situation_before_contract_pro = [
    {
        code: "",
        id: "unknown",
        label: "Je ne sais pas"
    },
    {
        code: "1",
        id: "school",
        label: "Scolaire"
    },
    {
        code: "2",
        id: "civis",
        label: "Jeune bénéficiaire du CIVIS"
    },
    {
        code: "3",
        id: "student",
        label: "Etudiant"
    },
    {
        code: "4",
        id: "apprenticeship_contract",
        label: "Contrat d'apprentissage"
    },
    {
        code: "5",
        id: "professionalization_contract",
        label: "Contrat de professionnalisation"
    },
    {
        code: "6",
        id: "aided_contract",
        label: "Salarié en contrat aidé : CUI-CIE, CUI-CAE"
    },
    {
        code: "7",
        id: "cfa_formation",
        label: "Stagiaire de la formation professionnelle"
    },
    {
        code: "8",
        id: "employee",
        label: "Salarié (y compris intérimaires et salariés à temps partiel)"
    },
    {
        code: "9",
        id: "job_seeker",
        label: "Personne à la recherche d'un emploi"
    },
    {
        code: "10",
        id: "inactive",
        label: "Inactif"
    }
];

export const commute_transports = [
    {
        id: "voiture",
        label: "Voiture"
    },
    {
        id: "transport_commun",
        label: "Transport en commun"
    },
    {
        id: "moto",
        label: "Moto"
    },
    {
        id: "velo",
        label: "Vélo"
    },
    {
        id: "autre",
        label: "Autre"
    }
];

export const travel_times = [
    {
        id: "10",
        label: "10 minutes"
    },
    {
        id: "15",
        label: "15 minutes"
    },
    {
        id: "20",
        label: "20 minutes"
    },
    {
        id: "30",
        label: "30 minutes"
    },
    {
        id: "45",
        label: "45 minutes"
    },
    {
        id: "60",
        label: "60 minutes"
    },
    {
        id: "75",
        label: "75 minutes"
    },
    {
        id: "90",
        label: "90 minutes"
    }
];

export const employer_types = [
    { id: "11", label: "Entreprise inscrite au répertoire des métiers ou au registre des entreprises pour l'Alsace-Moselle" },
    { id: "12", label: "Entreprise inscrite uniquement au registre du commerce et des sociétés" },
    { id: "13", label: "Entreprises dont les salariés relèvent de la mutualité sociale agricole" },
    { id: "14", label: "Profession libérale" },
    { id: "15", label: "Association" },
    { id: "16", label: "Autre employeur privé" },
    { id: "21", label: "Service de l'Etat (administrations centrales et leurs services déconcentrés de la fonction publique d'Etat)" },
    { id: "22", label: "Commune" },
    { id: "23", label: "Département" },
    { id: "24", label: "Région" },
    { id: "25", label: "Etablissement public hospitalier" },
    { id: "26", label: "Etablissement public local d'enseignement" },
    { id: "27", label: "Etablissement public administratif de l'Etat" },
    { id: "28", label: "Etablissement public administratif local (y compris établissement public de coopération intercommunale EPCI)" },
    { id: "29", label: "Autre employeur public" },
    { id: "30", label: "Etablissement public industriel et commercial" }
];

export const employer_specifications = [
    { id: "1", label: "Entreprise de travail temporaire" },
    { id: "2", label: "Groupement d'employeurs" },
    { id: "3", label: "Employeur saisonnier" },
    { id: "4", label: "Apprentissage familial : l'employeur est un ascendant de l'apprenti" },
    { id: "0", label: "Aucun de ces cas" }
];

export const diploma_levels = [
    { id: "0", label: "Sélectionner un diplôme" },
    { id: "3", label: "CAP, BEP" },
    { id: "4", label: "Baccalauréat" },
    { id: "5", label: "DEUG, BTS, DUT, DEUST" },
    { id: "6", label: "Licence, licence professionnelle, BUT, Maîtrise libérale" },
    { id: "7", label: "Master, diplôme d'études approfondies, diplôme d'études supérieures spécialisées, diplôme d'ingénieur" },
    { id: "8", label: "Doctorat, habilitation à diriger des recherches" }
];

export const contract_types = [
    { id: "11", label: "Premier contrat d'apprentissage de l'apprenti" },
    { id: "21", label: "Nouveau contrat avec un apprenti qui a terminé son précédent contrat auprès d'un même employeur" },
    { id: "22", label: "Nouveau contrat avec un apprenti qui a terminé son précédent contrat auprès d'un autre employeur" },
    { id: "23", label: "Nouveau contrat avec un apprenti dont le précédent contrat a été rompu" },
    { id: "31", label: "Modification de la situation juridique de l'employeur" },
    { id: "32", label: "Changement d'employeur dans le cadre d'un contrat saisonnier" },
    { id: "33", label: "Prolongation du contrat suite à un échec à l'examen de l'apprenti" },
    { id: "34", label: "Prolongation du contrat suite à la reconnaissance de l'apprenti comme travailleur handicapé" },
    { id: "35", label: "Diplôme supplémentaire préparé par l'apprenti dans le cadre de l'article L. 6222-22-1 du code du travail" },
    { id: "36", label: "Autres changements : changement de maître d'apprentissage, de durée de travail hebdomadaire, réduction de durée, etc." },
    { id: "37", label: "Modification du lieu d'exécution du contrat" },
    { id: "38", label: "Modification du lieu principal de réalisation de la formation théorique" }
];

export const derogation_types = [
    { id: "00", label: "Pas de dérogation" },
    { id: "11", label: "Âge de l'apprenti inférieur à 16 ans" },
    { id: "12", label: "Âge supérieur à 29 ans : cas spécifiques prévus dans le code du travail" },
    { id: "21", label: "Réduction de la durée du contrat ou de la période d'apprentissage" },
    { id: "22", label: "Allongement de la durée du contrat ou de la période d'apprentissage" },
    { id: "50", label: "Cumul de dérogations" },
    { id: "60", label: "Autre dérogation" }
];

export const contract_natures = [
    { id: "cdi", label: "CDI" },
    { id: "cdd", label: "CDD" },
    { id: "temporary_work", label: "Travail temporaire" }
];

export const social_minimum_types = [
    { id: "1", label: "rsa" },
    { id: "2", label: "ass" },
    { id: "3", label: "aah" }
];

export const job_interview_outcomes = [
    {
        id: "ToBeQualified",
        label: "A qualifier"
    },
    {
        id: "NoShow",
        label: "Le candidat ne s'est pas présenté"
    },
    {
        id: "Lost",
        label: "L'entreprise/le candidat ne souhaite pas poursuivre"
    },
    {
        id: "Won",
        label: "L'entreprise et le candidat souhaite poursuivre"
    },
    { id: "Trial", label: "Journée d'essai" },
    { id: "SecondInterview", label: "Le candidat a un 2ème entretien" },
    { id: "Interested", label: "Le candidat est intéressé (CV à positionner)" }
];

export const cerfa_apprenticeship_dictionnary = {
    // PAGE 1
    "employeur privé": "Case #C3#A0 cocher 1",
    "employeur public": "Case #C3#A0 cocher 2",
    "Sexe M": "Case #C3#A0 cocher 3",
    "Sexe F": "Case #C3#A0 cocher 4",
    "Déclare être inscrit sur la liste des sportifs de haut niveau OUI": "Case #C3#A0 cocher 5",
    "Déclare être inscrit sur la liste des sportifs de haut niveau NON": "Case #C3#A0 cocher 5_2",
    "Déclare bénéficier de la reconnaissance travailleur handicapé OUI": "Case #C3#A0 cocher 5_3",
    "Déclare bénéficier de la reconnaissance travailleur handicapé NON": "Case #C3#A0 cocher 5_4",
    "Equivalence jeunes OUI": "Case #C3#A0 cocher 5_5",
    "Equivalence jeunes NON": "Case #C3#A0 cocher 5_6",
    "Extension BOE OUI": "Case #C3#A0 cocher 5_7",
    "Extension BOE NON": "Case #C3#A0 cocher 5_8",
    "Déclare avoir un projet de création ou de reprise d’entreprise OUI": "Case #C3#A0 cocher 5_9",
    "Déclare avoir un projet de création ou de reprise d’entreprise NON": "Case #C3#A0 cocher 5_10",
    "Employeur atteste sur l'honneur": "Case #C3#A0 cocher 6",
    "Public assurance chomage": "Case #C3#A0 cocher 2_2",
    "Nom et prénom ou dénomination :": "Zone de texte 8",
    "Maître d’apprentissage n°2 Date naissance_af_date_jour": "Zone de texte 21",
    "Maître d’apprentissage n°2 Date naissance_af_date_mois": "Zone de texte 21_2",
    "Maître d’apprentissage n°2 Date naissance_af_date_annee": "Zone de texte 21_3",
    "Maître d’apprentissage n°1 Date naissance_af_date_jour": "Zone de texte 21_4",
    "Maître d’apprentissage n°1 Date naissance_af_date_mois": "Zone de texte 21_5",
    "Maître d’apprentissage n°1 Date naissance_af_date_annee": "Zone de texte 21_6",
    "Apprenti Date naissance_af_date_jour": "Zone de texte 21_7",
    "Apprenti Date naissance_af_date_mois": "Zone de texte 21_8",
    "Apprenti Date naissance_af_date_annee": "Zone de texte 21_9",
    "N°SIRET de l’établissement d’exécution du contrat :": "Zone de texte 8_2",
    "Type d’employeur": "Zone de texte 8_3",
    "Employeur spécifique": "Zone de texte 8_4",
    "Effectif total salariés de l’entreprise :": "Zone de texte 8_5",
    "Code IDCC de la convention collective applicable :": "Zone de texte 8_6",
    "Code activité de l’entreprise (NAF) :": "Zone de texte 8_7",
    Complement: "Zone de texte 8_8",
    "Code postal": "Zone de texte 8_9",
    Commune: "Zone de texte 8_10",
    Téléphone: "Zone de texte 8_11",
    Courriel: "Zone de texte 8_12",
    Voie: "Zone de texte 8_13",
    "N°": "Zone de texte 8_14",
    "Nom de naissance de l’apprenti(e) :": "Zone de texte 8_15",
    "Nom d’usage": "Zone de texte 8_16",
    "Le premier prénom de l’apprenti(e) selon l’état civil :": "Zone de texte 8_17",
    "NIR de l’apprenti(e)": "Zone de texte 8_18",
    "Adresse de l’apprenti(e) N°": "Zone de texte 8_19",
    "Adresse de l’apprenti(e) Voie": "Zone de texte 8_20",
    "Adresse de l’apprenti(e) Complement": "Zone de texte 8_21",
    "Adresse de l’apprenti(e) CP": "Zone de texte 8_22",
    "Adresse de l’apprenti(e) Commune": "Zone de texte 8_23",
    "Adresse de l’apprenti(e) Téléphone": "Zone de texte 8_24",
    "Adresse de l’apprenti(e) Courriel": "Zone de texte 8_25",
    "Département naissance apprenti": "Zone de texte 8_26",
    "Commune naissance apprenti": "Zone de texte 8_27",
    "Situation avant ce contrat": "Zone de texte 8_28",
    "Dernier diplôme ou titre préparé": "Zone de texte 8_29",
    "Dernière classe / année suivie": "Zone de texte 8_30",
    "Intitulé précis du dernier diplôme ou titre préparé :": "Zone de texte 8_31",
    "Diplôme ou titre le plus élevé obtenu": "Zone de texte 8_32",
    "Nationalité apprenti": "Zone de texte 8_33",
    "Régime social apprenti": "Zone de texte 8_34",
    "Représentant légal Nom / Prénom": "Zone de texte 8_35",
    "Adresse du représentant légal Voie": "Zone de texte 8_36",
    "Adresse du représentant légal N°": "Zone de texte 8_37",
    "Adresse du représentant légal Complement": "Zone de texte 8_38",
    "Adresse du représentant légal CP": "Zone de texte 8_39",
    "Adresse du représentant légal Commune": "Zone de texte 8_40",
    "Adresse du représentant légal Courriel": "Zone de texte 8_41",
    "Maître d’apprentissage n°1 Nom de naissance": "Zone de texte 8_42",
    "Maître d’apprentissage n°1 Prénom": "Zone de texte 8_43",
    "Maître d’apprentissage n°1 Courriel": "Zone de texte 8_44",
    "Maître d’apprentissage n°1 Emploi occupé :": "Zone de texte 8_45",
    "Maître d’apprentissage n°2 Nom de naissance": "Zone de texte 8_46",
    "Maître d’apprentissage n°2 Prénom": "Zone de texte 8_47",
    "Maître d’apprentissage n°2 Courriel": "Zone de texte 8_48",
    "Maître d’apprentissage n°2 Emploi occupé :": "Zone de texte 8_49",
    "Maître d’apprentissage n°1Diplôme ou titre le plus élevé obtenu :": "Zone de texte 8_50",
    "Maître d’apprentissage n°2Diplôme ou titre le plus élevé obtenu :": "Zone de texte 8_51",
    "Maître d’apprentissage n°1 Niveau de diplôme ou titre le plus élevé obtenu :": "Zone de texte 8_52",
    "Maître d’apprentissage n°2 Niveau de diplôme ou titre le plus élevé obtenu :": "Zone de texte 8_53",
    "Code mode contractuel": "Mode contractuel de l'apprentissage",
    // PAGE 2
    "CFA d’entreprise OUI": "Case #C3#A0 cocher 5_11",
    "CFA d’entreprise NON": "Case #C3#A0 cocher 5_12",
    "Si CFA responsable lieu de formation": "Case #C3#A0 cocher 7",
    "L’employeur atteste disposer de l’ensemble des pièces justificatives nécessaires au dépôt du contrat": "Case #C3#A0 cocher 8",
    "ate de fin du contrat ou de la période d'apprentissage_af_date_jour": "Zone de texte 21_10",
    "ate de fin du contrat ou de la période d'apprentissage_af_date_mois": "Zone de texte 21_11",
    "ate de fin du contrat ou de la période d'apprentissage_af_date_annee": "Zone de texte 21_12",
    "Si avenant, date d’effet :_af_date_jour": "Zone de texte 21_13",
    "Si avenant, date d’effet :_af_date_mois": "Zone de texte 21_14",
    "Si avenant, date d’effet :_af_date_annee": "Zone de texte 21_15",
    "Date de conclusion : _af_date_jour": "Zone de texte 21_16",
    "Date de conclusion : _af_date_mois": "Zone de texte 21_17",
    "Date de conclusion : _af_date_annee": "Zone de texte 21_18",
    "Date de début d’exécution du contrat : _af_date_jour": "Zone de texte 21_19",
    "Date de début d’exécution du contrat : _af_date_mois": "Zone de texte 21_20",
    "Date de début d’exécution du contrat : _af_date_annee": "Zone de texte 21_21",
    "Date de début de formation pratique chez l’employeur : _af_date_jour": "Zone de texte 21_22",
    "Date de début de formation pratique chez l’employeur : _af_date_mois": "Zone de texte 21_23",
    "Date de début de formation pratique chez l’employeur : _af_date_annee": "Zone de texte 21_24",
    "Date de début de formation en CFA :  _af_date_jour": "Zone de texte 21_25",
    "Date de début de formation en CFA :  _af_date_mois": "Zone de texte 21_26",
    "Date de début de formation en CFA :  _af_date_annee": "Zone de texte 21_27",
    "Date prévue de fin des épreuves ou examens :_af_date_jour": "Zone de texte 21_28",
    "Date prévue de fin des épreuves ou examens :_af_date_mois": "Zone de texte 21_29",
    "Date prévue de fin des épreuves ou examens :_af_date_annee": "Zone de texte 21_30",
    "Date de reception du contrat _af_date_jour": "Zone de texte 21_31",
    "Date de reception du contrat _af_date_mois": "Zone de texte 21_32",
    "Date de reception du contrat _af_date_annee": "Zone de texte 21_33",
    "Date de la decision _af_date_jour": "Zone de texte 21_34",
    "Date de la decision _af_date_mois": "Zone de texte 21_35",
    "Date de la decision _af_date_annee": "Zone de texte 21_36",
    "Numéro du contrat précédent ou du contrat sur lequel porte l’avenant :": "Zone de texte 8_54",
    "Rémunération - 2e  année, du _af_date_jour": "Zone de texte 21_37",
    "Rémunération - 2e  année, du _af_date_mois": "Zone de texte 21_38",
    "Rémunération - 2e  année, du _af_date_annee": "Zone de texte 21_39",
    "Rémunération - 2e  année, au_af_date_jour": "Zone de texte 21_40",
    "Rémunération - 2e  année, au_af_date_mois": "Zone de texte 21_41",
    "Rémunération - 2e  année, au_af_date_annee": "Zone de texte 21_42",
    "2e année % du": "Zone de texte 8_55",
    "2e année % du *": "Zone de texte 8_56",
    "Rémunération - 2e  année, du _af_date_jour BIS": "Zone de texte 21_43",
    "Rémunération - 2e  année, du _af_date_mois BIS": "Zone de texte 21_44",
    "Rémunération - 2e  année, du _af_date_annee BIS": "Zone de texte 21_45",
    "Rémunération - 2e  année, au_af_date_jour BIS": "Zone de texte 21_46",
    "Rémunération - 2e  année, au_af_date_mois BIS": "Zone de texte 21_47",
    "Rémunération - 2e  année, au_af_date_annee BIS": "Zone de texte 21_48",
    "2e année % du BIS": "Zone de texte 8_57",
    "2e année % du BIS *": "Zone de texte 8_58",
    "Rémunération - 3e  année, du _af_date_jour": "Zone de texte 21_49",
    "Rémunération - 3e  année, du _af_date_mois": "Zone de texte 21_50",
    "Rémunération - 3e  année, du _af_date_annee": "Zone de texte 21_51",
    "Rémunération - 3e  année, au_af_date_jour": "Zone de texte 21_52",
    "Rémunération - 3e  année, au_af_date_mois": "Zone de texte 21_53",
    "Rémunération - 3e  année, au_af_date_annee": "Zone de texte 21_54",
    "3e année % du": "Zone de texte 8_59",
    "3e année % du *": "Zone de texte 8_60",
    "Rémunération - 3e  année, du _af_date_jour BIS": "Zone de texte 21_55",
    "Rémunération - 3e  année, du _af_date_mois BIS": "Zone de texte 21_56",
    "Rémunération - 3e  année, du _af_date_annee BIS": "Zone de texte 21_57",
    "Rémunération - 3e  année, au_af_date_jour BIS": "Zone de texte 21_58",
    "Rémunération - 3e  année, au_af_date_mois BIS": "Zone de texte 21_59",
    "Rémunération - 3e  année, au_af_date_annee BIS": "Zone de texte 21_60",
    "3e année % du BIS": "Zone de texte 8_61",
    "3e année % du BIS *": "Zone de texte 8_62",
    "Rémunération - 4e  année, du _af_date_jour": "Zone de texte 21_61",
    "Rémunération - 4e  année, du _af_date_mois": "Zone de texte 21_62",
    "Rémunération - 4e  année, du _af_date_annee": "Zone de texte 21_63",
    "Rémunération - 4e  année, au_af_date_jour": "Zone de texte 21_64",
    "Rémunération - 4e  année, au_af_date_mois": "Zone de texte 21_65",
    "Rémunération - 4e  année, au_af_date_annee": "Zone de texte 21_66",
    "4e année % du": "Zone de texte 8_63",
    "4e année % du *": "Zone de texte 8_64",
    "Rémunération - 4e  année, du _af_date_jour BIS": "Zone de texte 21_67",
    "Rémunération - 4e  année, du _af_date_mois BIS": "Zone de texte 21_68",
    "Rémunération - 4e  année, du _af_date_annee BIS": "Zone de texte 21_69",
    "Rémunération - 4e  année, au_af_date_jour BIS": "Zone de texte 21_70",
    "Rémunération - 4e  année, au_af_date_mois BIS": "Zone de texte 21_71",
    "Rémunération - 4e  année, au_af_date_annee BIS": "Zone de texte 21_72",
    "4e année % du BIS": "Zone de texte 8_65",
    "4e année % du BIS *": "Zone de texte 8_66",
    "Durée hebdomadaire du travail  heure": "Zone de texte 8_67",
    "Durée hebdomadaire du travail  minutes": "Zone de texte 8_68",
    "Travail sur machines dangereuses ou exposition a des risques particuliers OUI": "Case #C3#A0 cocher 5_13",
    "Travail sur machines dangereuses ou exposition a des risques particuliers NON": "Case #C3#A0 cocher 5_14",
    "Type de dérogation :": "Zone de texte 8_69",
    "Type de contrat ou d’avenant :": "Zone de texte 8_70",
    "Salaire brut mensuel à l’embauche : EUR": "Zone de texte 8_71",
    "Salaire brut mensuel à l’embauche : CTS": "Zone de texte 21_73",
    "Caisse de retraite complémentaire :": "Zone de texte 21_74",
    "Avantages en nature, le cas échéant : Nourriture EUR": "Zone de texte 21_75",
    "Avantages en nature, le cas échéant : Nourriture CTS": "Zone de texte 21_76",
    "Avantages en nature, le cas échéant : Logement EUR": "Zone de texte 21_77",
    "Avantages en nature, le cas échéant : Logement CTS": "Zone de texte 21_78",
    "Avantages en nature, le cas échéant : Autre": "Zone de texte 21_79",
    "N° UAI du CFA": "Zone de texte 8_72",
    "N° SIRET CFA": "Zone de texte 8_73",
    "Code du diplôme": "Zone de texte 8_74",
    "Code RNCP": "Zone de texte 8_75",
    "Diplôme ou titre visé par l’apprenti :": "Zone de texte 8_76",
    "Durée de la formation :": "Zone de texte 21_80",
    "Dont heures de formation à distance": "Zone de texte 21_93",
    "Adresse du CFA responsable Commune": "Zone de texte 8_77",
    "Adresse du CFA responsable N°": "Zone de texte 8_78",
    "Adresse du CFA responsable Voie": "Zone de texte 8_79",
    "Adresse du CFA responsable Complement": "Zone de texte 8_80",
    "Adresse du CFA responsable CP": "Zone de texte 8_81",
    "N° SIRET CFA DIFFERENT": "Zone de texte 8_82",
    "N° UAI du CFA DIFFERENT": "Zone de texte 8_83",
    "Adresse du CFA responsable Commune DIFFERENT": "Zone de texte 8_84",
    "Adresse du CFA responsable N° DIFFERENT": "Zone de texte 8_85",
    "Adresse du CFA responsable Voie DIFFERENT": "Zone de texte 8_86",
    "Adresse du CFA responsable Complement DIFFERENT": "Zone de texte 8_87",
    "Adresse du CFA responsable CP DIFFERENT": "Zone de texte 8_88",
    "Fait à": "Zone de texte 8_89",
    "Nom de l'organisme": "Zone de texte 8_90",
    "N° SIRET de l'organisme": "Zone de texte 8_91",
    "Cadre réservé à l'ogarnisme N° de dépôt": "Zone de texte 8_92",
    "Cadre réservé à l'ogarnisme Numéro d'avenant": "Zone de texte 8_93",
    "Rémunération - 1re  année, du _af_date_jour": "Zone de texte 21_81",
    "Rémunération - 1re  année, du _af_date_mois": "Zone de texte 21_82",
    "Rémunération - 1re  année, du _af_date_annee": "Zone de texte 21_83",
    "Rémunération - 1re  année, au_af_date_jour": "Zone de texte 21_84",
    "Rémunération - 1re  année, au_af_date_mois": "Zone de texte 21_85",
    "Rémunération - 1re  année, au_af_date_annee": "Zone de texte 21_86",
    "1e année % du": "Zone de texte 8_94",
    "1e année % du *": "Zone de texte 8_95",
    "Rémunération - 1re  année, du _af_date_jour BIS": "Zone de texte 21_87",
    "Rémunération - 1re  année, du _af_date_mois BIS": "Zone de texte 21_88",
    "Rémunération - 1re  année, du _af_date_annee BIS": "Zone de texte 21_89",
    "Rémunération - 1re  année, au_af_date_jour BIS": "Zone de texte 21_90",
    "Rémunération - 1re  année, au_af_date_mois BIS": "Zone de texte 21_91",
    "Rémunération - 1re  année, au_af_date_annee BIS": "Zone de texte 21_92",
    "1e année % du BIS": "Zone de texte 8_96",
    "1e année % du BIS *": "Zone de texte 8_97",
    "Dénomination du CFA responsable :": "Zone de texte 8_98",
    "Diplôme ou titre visé par l’apprenti : Intitulé précis :": "Zone de texte 8_99",
    "Dénomination du CFA responsable : DIFFERENT": "Zone de texte 8_100"
};

export const aid_under_20s = [
    { id: "unknown", label: "Aucun" },
    { id: "PCH", label: "Prestation de Compensation du Handicap" },
    { id: "AEEH", label: "Allocation d'Education de l'Enfant Handicapé" },
    { id: "PPS", label: "Projet Personnalisé de Scolarisation" }
];

export const boe_types = [
    { id: "unknown", label: "Aucun" },
    { id: "ACCIDENT_TRAVAIL", label: "Accident du travail ou maladie professionnelle (≥ 10% d'incapacité)" },
    { id: "PENSION_INVALIDITE", label: "Pension d'invalidité (réduction de capacité ≥ 2/3)" },
    { id: "MILITAIRE_INVALIDITE", label: "Ancien militaire avec pension d'invalidité" },
    { id: "SAPEUR_POMPIER", label: "Sapeur-pompier volontaire avec rente d'invalidité" },
    { id: "VICTIME_TERRORISME", label: "Victime d'un acte de terrorisme" },
    { id: "CMI_INVALIDITE", label: "Carte mobilité inclusion (CMI) mention invalidité" },
    { id: "AAH", label: "Allocation aux adultes handicapés (AAH)" },
    { id: "ATI", label: "Allocation temporaire d'invalidité (ATI)" },
    { id: "RECLASSEMENT", label: "Fonctionnaire/contractuel en reclassement" }
];

export const discarded_reasons = [
    { value: "profile_not_suitable", label: "Le profil ne convient pas." },
    { value: "not_in_france", label: "Le candidat n'est pas sur le territoire français." },
    { value: "missing_admin_authorisation", label: "Le candidat ne dispose pas des autorisations administratives nécessaires" },
    { value: "other_professional_project", label: "Le candidat a trouvé un autre projet professionnel" },
    { value: "other_apprenticeship", label: "Le candidat a trouvé une autre alternance." },
    { value: "prerequisites_not_met", label: "Le candidat ne remplit pas les prérequis de la formation" }
];

export const csp_choices = [
    { value: "unskilled_worker", label: "Ouvriers Non Qualifiés" },
    { value: "skilled_worker", label: "Ouvriers Qualifiés" },
    { value: "employee", label: "Employés" },
    { value: "technician", label: "Technicien / Agent de Maitrise" },
    { value: "staff", label: "Ingénieur / Cadre" },
    { value: "employed_executive", label: "Dirigeants Salariés" },
    { value: "unemployed_executive", label: "Dirigeants Non Salariés" },
];

export const study_level_choices = [
    { value: "bachelor_master", label: "Niveau I/II (Bac +3/+5)" },
    { value: "bts", label: "Niveau III (Bac +2)" },
    { value: "baccalaureate", label: "Niveau IV (Bac)" },
    { value: "not_applicable", label: "Non concerné (étude ou diplôme non reconnu en France)" },
    { value: "unknown", label: "Inconnu" },
];